import { range } from "lodash";
import { getWidth } from "../common";

const columns = 6;
export default range(6).map(current => {
  const field = `sensor_flow_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true
  };
});
